<div class="container-fluid">
    <img class="img-responsive" src="../../assets/Service-book.jpg" class="img">
    <div class="top-left">
        <h1>Book Service</h1>
    </div>
</div>

<div class="container">

    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <h2>Schedule Online</h2>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="nxtBtn">
            <div class="calendar">
                <h4>Select your preferred date:</h4>
                <div>
                    <bs-datepicker-inline bsDatepicker [(bsValue)]="cal" [bsConfig]="bsconfig" class="datepicker">
                    </bs-datepicker-inline>
                </div>
            </div>
            <div class="time">
                <h4>Select your preferred time:</h4>

                <div class="col-sm-4 col-xs-4">
                    <h5 class="tslot">Morning</h5>
                    <button type="button" id="1" [ngClass]="'1'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('1','10:00 AM')">10:00 AM</button>
                    <button type="button" id="2" [ngClass]="'2'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('2','10:30 AM')">10:30 AM</button>
                    <button type="button" id="3" [ngClass]="'3'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('3','11:00 AM')">11:00 AM</button>
                    <button type="button" id="4" [ngClass]="'4'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('4','10:30 AM')">11:30 AM</button>
                </div>
                <div class="col-sm-4 col-xs-4">
                    <h5 class="tslot">Afternoon</h5>
                    <button type="button" id="5" [ngClass]="'5'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('5','01:00 PM')">01:00 PM</button>
                    <button type="button" id="6" [ngClass]="'6'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('6','01:30 PM')">01:30 PM</button>
                    <button type="button" id="7" [ngClass]="'7'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('7','02:00 PM')">02:00 PM</button>
                    <button type="button" id="8" [ngClass]="'8'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('8','02:30 PM')">02:30 PM</button>
                </div>
                <div class="col-sm-4 col-xs-4">
                    <h5 class="tslot">Evening</h5>
                    <button type="button" id="9" [ngClass]="'9'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('9','04:00 PM')">04:00 PM</button>
                    <button type="button" id="10" [ngClass]="'10'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('10','04:30 PM')">04:30 PM</button>
                    <button type="button" id="11" [ngClass]="'11'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('11','05:00 PM')">05:00 PM</button>
                    <button type="button" id="12" [ngClass]="'12'== selectedId?'gcb':'wcb'"
                        (click)="selectedTime('12','05:30 PM')">05:30 PM</button>
                </div>
            </div>
            <!-- buttons -->
            <div class="center-btn" *ngIf="nxtBtn">
                <button type="button" class="nxtBtn" (click)=" nxtBtn = false">Next</button>
            </div>
        </div>

        <!-- nxt page -->
        <div class="col-lg-6 col-md-6 col-sm-6 form-field" *ngIf="!nxtBtn">
            <div>
                <h4>Enter your details to complete the booking :</h4>
                <form [formGroup]="reqForm">
                    <div class="container">
                        <div class="form-group">
                            <label for="exampleInputName">Name</label>
                            <input type="text" class="form-control" id="exampleInputName2" placeholder="Your Answer"
                                formControlName="customerName">
                        </div>
                        <div
                            *ngIf="reqForm.get('customerName').hasError('required') && reqForm.get('customerName').touched">
                            <small class="error">Name should not be empty</small>
                        </div>
                        <div
                            *ngIf="reqForm.get('customerName').hasError('minlength')&& reqForm.get('customerName').touched">
                            <small class="error">Name should contain minimum 3 characters</small>
                        </div>
                        <div
                            *ngIf="reqForm.get('customerName').hasError('maxlength')&& reqForm.get('customerName').touched">
                            <small class="error">Name should contain maximum 35 characters</small>
                        </div>
                        <div
                            *ngIf="reqForm.get('customerName').hasError('pattern')&& reqForm.get('customerName').touched">
                            <small class="error">Please enter only Alphabets</small>
                        </div>
                    </div>
                    <div class="container">
                        <div class="form-group">
                            <label for="phone">Phone</label>
                            <input type="tel" class="form-control" id="phone" name="phone" placeholder="Your Answer"
                                formControlName="phoneNumber">
                        </div>
                        <div
                            *ngIf="reqForm.get('phoneNumber').hasError('required')&& reqForm.get('phoneNumber').touched">
                            <small class="error">Please enter your phone number</small>
                        </div>
                        <div
                            *ngIf="reqForm.get('phoneNumber').hasError('pattern')&& reqForm.get('phoneNumber').touched;else test">
                            <small class="error">Please enter in digits</small>
                        </div>
                        <ng-template #test>
                            <div
                                *ngIf="reqForm.get('phoneNumber').hasError('minlength')&& reqForm.get('phoneNumber').touched">
                                <small class="error">Please enter minimum 10 digits</small>
                            </div>
                            <div
                                *ngIf="reqForm.get('phoneNumber').hasError('maxlength')&& reqForm.get('phoneNumber').touched">
                                <small class="error">Please enter maximum 10 digits</small>
                            </div>
                        </ng-template>
                    </div>
                    <div class="container">
                        <div class="form-group">
                            <label for="exampleInputEmail">Email</label>
                            <input type="email" class="form-control" id="exampleInputEmail2" placeholder="Your Answer"
                                formControlName="email">
                        </div>
                        <div *ngIf="reqForm.get('email').hasError('required')&& reqForm.get('email').touched">
                            <small class="error">Please enter your Email</small>
                        </div>
                        <div *ngIf="reqForm.get('email').hasError('email')&& reqForm.get('email').touched">
                            <small class="error">Please enter a valid Email</small>
                        </div>
                    </div>
                    <div class="container">
                        <div class="form-group">
                            <label for="exampleInputName">Message</label>
                            <textarea class="form-control" rows="3" formControlName="message"></textarea>
                        </div>
                    </div>

                    <div class="center-btn">
                        <button type="button" class="bb2" (click)="nxtBtn = true">Back</button>
                        <button type="button" class="bb" (click)="submitReq()">Book</button>
                    </div>
                </form>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="address">
                <h3>{{subCat}}</h3>
                <p ><span class="qst">Date :</span> {{cal|date:'dd/MM/yyyy'}}</p>
                <p ><span class="qst">Time :</span> {{schdTime}}</p>
                <p><span class="qst">Store Name :</span>
                    <select name="storename" [(ngModel)]="getAddressId"
                        (change)="selectedAddress(getAddressId)">
                        <option class="optClr" *ngFor="let details of getAddress" value="{{details.id}}">{{details.serviceStorename}}
                        </option>
                    </select> </p>
                <p><span class="qst">Address :</span> {{select_address?.addressDetails}}</p>
            </div>
        </div>
    </div>


</div>


<ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Message</h4>
        <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
                class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
        <p class="text-center">{{modal.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      
        <button type="button" class="btn-blue" routerLink="/service" (click)="modalClose()"> OK</button>
    </div>
</ng-template>